import { ComponentRenderHooks, ListItemsHooks } from "@launchos/plugins/types";
import LiveButton from "./component";

export const onComponentRender = (hook, payload, actions) => {
  if (hook.id === ComponentRenderHooks.WEBCOMPONENT && payload.type === "Button") {
    return [LiveButton];
  }
};
